import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import { LanguageProvider } from './contexts/LanguageContext';
import AppShellShadcn from './layout/AppShell.shadcn';
import { Home, DeckBuilder, CardGallery, About, SampleDecks, DeckView, Blog, BlogPost, Videos, Animations, MetaAnalytics, TournamentDecks, TournamentDeckView, SetList, SetIndex } from './pages';
import { TooltipProvider } from './components/ui/tooltip';
import { HelmetProvider } from 'react-helmet-async';
import { isFeatureEnabled } from './constants';

function App() {
  return (
    <HelmetProvider>
      <TooltipProvider>
        <BrowserRouter>
          <LanguageProvider>
            <Routes>
              <Route path="/" element={<AppShellShadcn />}>
                <Route index element={<Home />} />
                <Route path="deck-builder" element={<DeckBuilder />} />
                <Route path="gallery" element={<CardGallery />} />
                {isFeatureEnabled('SET_REVEALS') && (
                  <Route path="sets" element={<SetIndex />} />
                )}
                {isFeatureEnabled('SET_REVEALS') && (
                  <Route path="sets/:setCode" element={<SetList />} />
                )}
                <Route path="decks" element={<SampleDecks />} />
                <Route path="decks/view/:deckId" element={<DeckView />} />
                {isFeatureEnabled('META_ANALYTICS') && (
                  <Route path="meta" element={<MetaAnalytics />} />
                )}
                {isFeatureEnabled('META_ANALYTICS') && (
                  <Route path="decks/tournament" element={<TournamentDecks />} />
                )}
                {isFeatureEnabled('META_ANALYTICS') && (
                  <Route path="decks/tournament/:code" element={<TournamentDeckView />} />
                )}
                <Route path="about" element={<About />} />
                <Route path="blog" element={<Blog />} />
                <Route path="blog/:slug" element={<BlogPost />} />
                <Route path="videos" element={<Videos />} />
                {isFeatureEnabled('ANIMATIONS_TOOL') && (
                  <Route path="animations" element={<Animations />} />
                )}
              </Route>
            </Routes>
          </LanguageProvider>
        </BrowserRouter>
      </TooltipProvider>
    </HelmetProvider>
  );
}

export default App;
